import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from './ThemeContext';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const opt = (t: 'light' | 'dark' | 'system', Icon: any, label: string) => (
    <button onClick={() => setTheme(t)}
      title={label}
      className={`p-1.5 rounded transition ${theme === t ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900 dark:text-indigo-200' : 'text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-700'}`}>
      <Icon size={14} />
    </button>
  );
  return (
    <div className="inline-flex items-center gap-0.5 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 bg-white dark:bg-slate-800">
      {opt('light', Sun, 'Light')}
      {opt('system', Monitor, 'System')}
      {opt('dark', Moon, 'Dark')}
    </div>
  );
}
